<template>
  <div class="el-main">
    <div class="Ecard">
      <!-- <el-select v-model="filterForm.by" style="width: 180px" class="mx-4 mt-4" @change="onByChange">
        <el-option label="资源" value="asset" />
        <el-option label="部件" value="part" />
        <el-option label="质量等级" value="quality" />
        <el-option label="皮肤" value="skin" />
      </el-select> -->

      <el-select v-model="filterForm.overType" class="mx-4 mt-4">
        <el-option label="超标" value="non"></el-option>
        <el-option label="严重超标" value="serious"></el-option>
      </el-select>

      <div v-for="quality of qualityOption" :key="quality" class="mt-4">
        <h1 class="fs-5 px-4">{{ quality }}</h1>
        <ul class="list-unstyled d-flex justify-content-between px-5 mt-2">
          <li v-for="typeVal of typeOption" :key="typeVal">
            <div class="rounded-circle border d-flex flex-column align-items-center justify-content-center fs-2 over-num">
              <span class="text-danger">{{ getOverNum(typeVal, quality).val }}</span>
              <span class="border-top border-dark border-3 px-1">{{ getOverNum(typeVal, quality).all }}</span>
            </div>
            <div class="text-center mt-2">{{ typeVal }}</div>
          </li>
        </ul>
      </div>

      <div ref="overLinesParent" class="d-flex flex-wrap px-4 mt-5">
        <div v-for="(chart, index) of assetOverLines" :key="chart.type" class="mb-5" :class="`${index ? 'w-50' : 'w-100'}`">
          <div style="height: 500px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, nextTick} from 'vue'
import {useRoute} from 'vue-router'
import * as echarts from 'echarts'
import axios from 'axios'

function useChart(project, filterForm) {
  let assetOverLines = ref([]),
    overLinesParent = ref(null)

  function getOption({titleText, data} = {}) {
    return {
      color: ['rgb(145, 204, 117)', 'rgb(250, 200, 88)', 'rgb(238, 102, 102)'],
      title: {
        text: titleText
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        data: ['合规', '不合规', '严重不合规'],
        bottom: 0,
      },
      grid: {
        left: '3%',
        right: '5%',
        bottom: 30,
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: data['日期']
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: '合规',
          type: 'line',
          stack: 'Total',
          smooth: true,
          lineStyle: {
            width: 0
          },
          showSymbol: false,
          areaStyle: {
            opacity: 0.8,
            color: 'rgb(145, 204, 117)'
          },
          emphasis: {
            focus: 'series'
          },
          data: data['合格']
        },
        {
          name: '不合规',
          type: 'line',
          stack: 'Total',
          smooth: true,
          lineStyle: {
            width: 0
          },
          showSymbol: false,
          areaStyle: {
            opacity: 0.8,
            color: 'rgb(250, 200, 88)'
          },
          emphasis: {
            focus: 'series'
          },
          data: data['不合格']
        },
        {
          name: '严重不合规',
          type: 'line',
          stack: 'Total',
          smooth: true,
          lineStyle: {
            width: 0
          },
          showSymbol: false,
          areaStyle: {
            opacity: 0.8,
            color: 'rgb(238, 102, 102)'
          },
          emphasis: {
            focus: 'series'
          },
          data: data['严重不合格']
        },
      ]
    }
  }

  async function drawChart() {
    const {by} = filterForm.value
    const {data} = await axios(`memory/resource_overview_trend/?project=${project}&by=${by}`)
    assetOverLines.value = Object.entries(data)
      .filter(([type, data]) => type != '项目整体')
      .map(([type, data]) => {
        return {type, data}
      })

    assetOverLines.value.unshift({type: '项目整体', data: data['项目整体']})
    await nextTick()
    assetOverLines.value.forEach((line, index) => {
      const chartDom = overLinesParent.value.children[index].children[0]
      const myChart = echarts.init(chartDom)
      myChart.setOption(getOption({titleText: `${line.type}超标资源数量变化`, data: line.data}))
    })
  }

  onMounted(drawChart)

  return {assetOverLines, overLinesParent, drawChart}
}

function useFilterForm(project, getOverviewData, filterForm) {
  let dateOption = ref([]),
    versionOption = ref([]),
    allOption = ref({})

  async function getOption() {
    const {data} = await axios(`memory/resource_version_list/?project=${project}`)

    allOption.value = data
    versionOption.value = Object.keys(data)
    const version = versionOption.value[0]
    dateOption.value = data[version]
    filterForm.value = {
      version,
      testTime: dateOption.value[0]
    }
  }

  return {dateOption, versionOption, getOption}
}

function useOverView(project, filterForm) {
  let qualityOption = ['整体数据', '超高质量等级', '高质量等级', '中质量等级', '低质量等级', '超低质量等级'],
    typeOption = ['赛车', '人物', '宠物', '骑宠', '座椅', '场景'],
    overData = ref({})

  async function getOverviewData() {
    const {by} = filterForm.value
    let {data} = await axios(`memory/resource_overview_v1/?project=${project}`)
    overData.value = data['超标数']
  }

  function getOverNum(typeVal, quality) {
    const {non, serious, all} = overData.value[typeVal] ? overData.value[typeVal][quality] : {}
    return {val: filterForm.value.overType == 'non' ? non : serious, all}
  }

  return {overData, qualityOption, typeOption, getOverviewData, getOverNum}
}

function test() {
  axios('memory/resource_overview/?project=7&Versions=1.00.0.00002&ScanTime=2024-09-30T11:33:04')
}

export default {
  setup() {
    const route = useRoute(),
      project = route.query.project,
      filterForm = ref({
        by: 'asset',
        overType: 'non'
      }),
      {overData, qualityOption, typeOption, getOverviewData, getOverNum} = useOverView(project, filterForm),
      {dateOption, versionOption, onVersionChange, getOption} = useFilterForm(project, getOverviewData, filterForm),
      {assetOverLines, overLinesParent, drawChart} = useChart(project, filterForm)

    async function onCreated() {
      getOverviewData()
    }

    function onByChange() {
      getOverviewData()
      drawChart()
    }

    onCreated()

    return {overData, qualityOption, typeOption, filterForm, dateOption, versionOption, assetOverLines, overLinesParent, getOverviewData, onByChange, getOverNum}
  },
}
</script>

<style scoped>
.Ecard {
  width: 70%;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 2px 10px rgb(179 186 220 / 40%);
  font-size: 15px;
}

.over-num {
  width: 150px;
  height: 150px;
}
</style>